import { render, staticRenderFns } from "./TimeDisplayField.vue?vue&type=template&id=4e023b24&scoped=true&"
import script from "./TimeDisplayField.vue?vue&type=script&lang=js&"
export * from "./TimeDisplayField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e023b24",
  null
  
)

export default component.exports